import { Paper } from "@mui/material";

// KNOWN FOLLOW-UP (PingOne migration, ASTT-7115): autoAuth=true below relies on
// an ambient Entra ID browser session that was previously a side effect of
// ASTT's own Entra login. Once ASTT logs in via PingOne, that side effect goes
// away, and this embed's silent auth may stop working for users with no other
// Microsoft session in the browser. Tracked separately, not fixed here.
function SummaryAnalysis() {
  const reportId = "329c80a1-32a9-449a-9f43-a617f480216b";
  const tenantId = "5d5c9a50-c854-4ea3-b05d-16388b14d5b3";

  const embedUrl =
    `https://app.powerbi.com/reportEmbed` +
    `?reportId=${reportId}` +
    `&autoAuth=true` +
    `&ctid=${tenantId}`;

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.35)",
        p: 2,
        height: "calc(100vh - 80px)",
        width: "calc(100vw - 110px)",
        mt: 1,
        ml: 2,
      }}
    >
      <iframe
        title="Power BI Report"
        src={embedUrl}
        width="100%"
        height="650x"
        style={{ border: "none" }}
        allowFullScreen
      />
    </Paper>
  );
}

export default SummaryAnalysis;
